import { BaseExceptionApi } from '@/data/exceptions/BaseExceptionApi'

export class ExceptionApiNotFound extends BaseExceptionApi {
  constructor(message: string) {
    super('ExceptionApiNotFound', 'NOT_FOUND', message)
  }
}
